import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export const useAmazonAttachment = ({
  patientId,
  encounterId,
  filename,
}: {
  patientId: string;
  encounterId: string;
  filename: string;
}) => {
  return useApi({
    queryOptions: {
      queryKey: QueryKeys.Patient.Files.AMAZON({
        patientId,
        encounterId,
        filename,
      }),
      enabled: Boolean(encounterId && filename),
      queryFn: async () => {
        const response = await axiosInstance.get(
          "/amazon-clinic/attachments/download",
          {
            params: {
              filename,
            },
            responseType: "blob",
          },
        );
        return response.data;
      },
    },
  });
};
